import './header.scss';

export default async () => {
	$( '.navigation__menu > ul > li > ul, .navigation__menu > ul > li > ul > li > ul' ).parent( 'li' ).addClass( 'has-children' );
	$( '.navigation__menu > ul > .has-children > a' ).append().after( '<span class=\'navigation__arrow js-menu-toggle\'><i class=\'fa-regular fa-chevron-down\'></i></span>' );
	$( '.js-menu-toggle' ).click( function ( e ) {
		e.preventDefault();
		let $this = $( this );

		if ( $this.hasClass( 'active' ) ) {
			$this.removeClass( 'active' );
			$this.next().slideUp( 350 );
		} else {
			$this.parent().parent().find( '.js-menu-toggle' ).removeClass( 'active' );
			$this.parent().parent().find( '.has-children ul' ).slideUp( 350 );
			$this.toggleClass( 'active' );
			$this.next().slideToggle( 350 );
		}
	} );

	// Toggle-menu
	$( '.js-toggle-menu' ).click( function ( e ) {
		e.preventDefault();
		$( 'body' ).toggleClass( 'is-menu-open' );
	} );

	$( '.header__menu > ul > li > ul' ).parent( 'li' ).addClass( 'has-children' );

	// Toggle-menu
	let $categorydropdown = $( '.header__menu > ul > li.has-children' );

	$categorydropdown.mouseover( function () {
		$( '.header' ).addClass( 'is-menu-hover' );
	} );
	$categorydropdown.mouseout( function () {
		$( '.header' ).removeClass( 'is-menu-hover' );
	} );
};
